import React from 'react';
import { BarChart3, TrendingUp, TrendingDown, Users } from 'lucide-react';

const StatsBar = ({ stats }) => {
  const items = [
    {
      key: 'instruments',
      cls: 'pm-stat--instruments',
      icon: BarChart3,
      label: 'Instruments',
      value: (stats.totalInstruments || 0).toLocaleString(),
    },
    {
      key: 'long',
      cls: 'pm-stat--long',
      icon: TrendingUp,
      label: 'Net Long',
      value: (stats.longPositions || 0).toLocaleString(),
      sub: 'instruments',
    },
    {
      key: 'short',
      cls: 'pm-stat--short',
      icon: TrendingDown,
      label: 'Net Short',
      value: (stats.shortPositions || 0).toLocaleString(),
      sub: 'instruments',
    },
    {
      key: 'users',
      cls: 'pm-stat--users',
      icon: Users,
      label: 'Active Users',
      value: (stats.totalUsers || 0).toLocaleString(),
    },
  ];

  return (
    <div className="pm-stats">
      {items.map(({ key, cls, icon: Icon, label, value, sub }) => (
        <div className={`pm-stat ${cls}`} key={key}>
          <div className="pm-stat-icon">
            <Icon />
          </div>
          <div>
            <div className="pm-stat-label">{label}</div>
            <div className="pm-stat-value">{value}</div>
            {sub && <div className="pm-stat-sub">{sub}</div>}
          </div>
        </div>
      ))}
    </div>
  );
};

export default StatsBar;
